module.exports = __webpack_public_path__ + "img/logo_mmt_blanco_transparente.98e42d61.png";